import React, { useEffect, useState } from 'react';
import { CardIcon } from '../../../components/Card';
import { MaximusPoolWithValue, PoolTypes } from '../../../maximus/lib/types';
import { toDisplayBalanceComma } from '../../../maximus/utils';
import { useHistory } from 'react-router-dom';
import { ZERO } from "../../../maximus/utils";
// import { LeftCornerRibbon } from "react-ribbons";

interface FarmCardProps {
  pool: MaximusPoolWithValue;
}

interface FarmCardOptions {
  isFlip: boolean;
  isCakeMaximizer: boolean;
  isMultiplexer: boolean;
  isBoost: boolean;
  isAPR: boolean;
  isClosed?: boolean;
}

const JOE_XJOE_RATIO = 1.20334;

const FarmCard: React.FC<FarmCardProps> = ({ pool }) => {
  const [poolOptions, setPoolOptions] = useState({
    isFlip: false,
    isCakeMaximizer: false,
    isMultiplexer: false,
    isBoost: false,
    isAPR: false,
    isClosed: false,
  } as FarmCardOptions);
  const history = useHistory();

  const deposited = (!pool.closed && pool.portfolio.gt(ZERO))

  useEffect(() => {
    setPoolOptions({
      isFlip: pool.deposit.endsWith('LP'),
      isCakeMaximizer: pool.name.endsWith('CAKE Maximizer'),
      isMultiplexer: pool.name.endsWith('Multiplexer'),
      isBoost: pool.name.includes('MAXI'),
      isAPR:
        pool.type === PoolTypes.Maximus ||
        pool.type === PoolTypes.MaximusAVAX ||
        pool.type === PoolTypes.MaximusStake,
      isClosed: pool.closed,
    });
  }, [pool, setPoolOptions]);

  const getApy = (): string | undefined => {
    switch (pool.type) {
      case PoolTypes.FlipToFlip:
        return (
          parseInt(pool.apyPool || '') + parseInt(pool.apySwap || '')
        ).toString();
      default:
        return pool.apy;
    }
  };

  const renderRate = () => {
    if (poolOptions.isClosed) {
      return <span className="description closed">{pool.summary}</span>;
    }

    return poolOptions.isAPR ? (
      <>
        <div className="apy">
          <div className="info-guide-for-manual-apy">
            <span>{parseFloat(pool.apy || '0').toFixed(2)}%</span>
          </div>
        </div>
        <span className="apr">
          APR {parseFloat(pool.apr || '0').toFixed(2)}%
        </span>
        <span className="description">{pool.summary}</span>
      </>
    ) : (
      <>
        <span className="apy">{parseFloat(getApy() || '0').toFixed(2)}%</span>
        <span className="description">{pool.summary}</span>
      </>
    );
  };
  return (
    <div


      className={`farms-card-item clickable ${deposited && 'deposited'} ${
        poolOptions.isBoost && !poolOptions.isClosed && 'boost'
      } ${poolOptions.isClosed && 'closed'}`}
      onClick={() => history.push(`/pool/${pool.path}`)}>

      {/* {deposited && 
      <LeftCornerRibbon backgroundColor="#FBBF0F" color="#000" >
        Deposited
      </LeftCornerRibbon>
      } */}

      <div className="icon">
        <CardIcon tokens={pool.tokens} />
      </div>

      <div className="label">
        <span>{pool.deposit}</span>
        {pool.swap && (
          <span className={`swap ${pool.swap?.toLowerCase()}`}>
            {pool.swap}
          </span>
        )}
      </div>

      <div className="rates">{renderRate()}</div>
      <div className="details return">
        <span className="label">Earn</span>
        <span className="value">{pool.earn}</span>
      </div>

      <div className="details balance">
        <span className="label">Balance</span>
        <span className="value">
          $
          {toDisplayBalanceComma(
            pool.portfolio.multipliedBy(
              // @ts-ignore
              pool.type === 'joeStake' ? JOE_XJOE_RATIO : 1
            )
          )}
        </span>
      </div>

      <div className="details total">
        <span className="label">Total Deposit</span>
        <span className="value">
          $
          {toDisplayBalanceComma(
            // @ts-ignore
            pool.tvl.multipliedBy(pool.type === 'joeStake' ? JOE_XJOE_RATIO : 1)
          )}
        </span>
      </div>
    </div>
  );
};

export default FarmCard;
